import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { StoreProvider } from './auth/StoreContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';

import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { StoresPage } from './pages/StoresPage';
import { UsersPage } from './pages/UsersPage';
import { CategoriesPage } from './pages/CategoriesPage';
import { ProductsPage } from './pages/ProductsPage';
import { CouponsPage } from './pages/CouponsPage';
import { SalesReportPage } from './pages/SalesReportPage';
import { AnalyticsReportPage } from './pages/AnalyticsReportPage';
import { BillsPage } from './pages/BillsPage';
import { CancelledBillsPage } from './pages/CancelledBillsPage';
import { RefundsPage } from './pages/RefundsPage';
import { BillDetailPage } from './pages/BillDetailPage';
import { AuditLogsPage } from './pages/AuditLogsPage';
import { SettingsPage } from './pages/SettingsPage';
import { PrinterConfigPage } from './pages/PrinterConfigPage';

function AdminShell() {
  return (
    <StoreProvider>
      <Layout />
    </StoreProvider>
  );
}

export default function App() {
  const { isAuthenticated, loading } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated && !loading ? <Navigate to="/" replace /> : <LoginPage />
        }
      />

      <Route
        element={
          <ProtectedRoute roles={['SUPER_ADMIN', 'STORE_ADMIN']}>
            <AdminShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="coupons" element={<CouponsPage />} />
        <Route path="reports/sales" element={<SalesReportPage />} />
        <Route path="reports/analytics" element={<AnalyticsReportPage />} />
        <Route path="bills" element={<BillsPage />} />
        <Route path="bills/cancelled" element={<CancelledBillsPage />} />
        <Route path="bills/refunds" element={<RefundsPage />} />
        <Route path="bills/:id" element={<BillDetailPage />} />
        <Route path="printers" element={<PrinterConfigPage />} />
        <Route path="audit" element={<AuditLogsPage />} />

        {/* Super-admin only */}
        <Route
          path="stores"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN']}>
              <StoresPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="users"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN']}>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="settings"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN']}>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
